<template>
  <div class="footer">
    <div class="container">
      <div class="columns is-mobile">
        <!-- column left -->
        <div v-if="window.width > 1023" class="has-text-left column">
          <p>
            <img class="icon" src="~@/assets/img/public_logo.png" /><span
              >eventify</span
            >
          </p>
        </div>
        <!-- column centered -->
        <div v-if="window.width > 1023" class="column has-text-centered">{{ myfooter }}</div>
        <!-- column right -->
        <div class="column">
          <div class="has-text-right">
            <img
              @click="choosenLanguageFunction('fr')"
              class="icon-flag"
              src="~@/assets/img/fr-2.png"
            />
            <img
              @click="choosenLanguageFunction('en')"
              class="icon-flag"
              src="~@/assets/img/en-2.png"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      myfooter: process.env.FOOTER,
    }
  },
  props: {
    window: {
      required: true
    }
  },
  methods:{
    choosenLanguageFunction (lang) {
      this.$i18n.locale = lang
      var selectlangue = lang
      this.$store.dispatch('changeLangue', selectlangue)
    }
  }
}
</script>

<style scoped>
#selectlangue{
  background-color:transparent;
  border:none
}
.footer {
  padding: 2px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #424a60;
  color: white;
  font-size: 12px;
  height: 35px;
  line-height: 25px;
  width: 100%;
}
.select {
  border-radius: 0px;
}
.icon {
  vertical-align: middle;
  height: 20px;
  width: auto;
}
.control {
  text-align:right;
}
.icon-flag {
  vertical-align: middle;
  height: 15px;
  width: 20px;
  margin-right: 8px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue